import Nixi1Spinner from 'components/Nixi1Spinner'
import React from 'react'

const DisplayButtons = ({ readOnly, sending, onResetValue, onSubmit, onEdit }) => {
  const className = 'position-absolute d-inline-flex justify-content-end align-items-center cod_client-buttons_container'

  if (readOnly && !sending) return (
    <div className={className}>
      <div className='p-1 d-inline-flex justify-content-center cod_client-buttons_container-btn' onClick={onEdit}>
        <i className='fa fa-pencil m-0 p-0' aria-hidden='true'></i>
      </div>
    </div>
  )

  if (!readOnly) {
    return (
      <div className={className}>
        <div className='p-1 d-inline-flex justify-content-center cod_client-buttons_container-btn' onClick={onResetValue}>
          <i className='fa fa-times-circle m-0 p-0 cancel_btn' aria-hidden='true'></i>
        </div>
        <div className='p-1 d-inline-flex justify-content-center cod_client-buttons_container-btn' onClick={onSubmit}>
          <i className='fa fa-refresh m-0 p-0' aria-hidden='true'></i>
        </div>
      </div>
    )
  }

  if (sending) {
    return (
      <div className={className}>
        <div className='p-1 d-inline-flex justify-content-center cod_client-buttons_container-btn'>
          <Nixi1Spinner width='25px' height='25px'/> 
        </div>
      </div>
    )
  }
}

export default DisplayButtons
